import React from 'react';
import PropTypes from 'prop-types';

import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

const VirtualizedList = ({
  itemCount,
  itemSize,
  overscanCount = 20,
  renderRow,
}) => (
  <AutoSizer>
    {({ width, height }) => (
      <FixedSizeList
        height={height}
        width={width}
        itemSize={itemSize}
        itemCount={itemCount}
        overscanCount={overscanCount}
        style={{
          msOverflowStyle: '-ms-autohiding-scrollbar',
          backgroundImage:
            'repeating-linear-gradient(#fff, #fff 54px, #f6f8f5 54px, #f6f8f5 108px)',
        }}
      >
        {({ index, style }) => (
          <div style={style}>{renderRow(index, style)}</div>
        )}
      </FixedSizeList>
    )}
  </AutoSizer>
);

VirtualizedList.propTypes = {
  itemCount: PropTypes.number.isRequired,
  itemSize: PropTypes.number.isRequired,
  overscanCount: PropTypes.number,
  renderRow: PropTypes.func.isRequired,
};

export default VirtualizedList;
